function shouldSuppressStickyPurchase({ hasPassed, isMobile, hasOverlay, hasFocusedField, keyboardVisible }) {
  return !hasPassed || !isMobile || hasOverlay || hasFocusedField || keyboardVisible;
}

function guardStickyPurchase(surface) {
  const sticky = surface?.querySelector('sticky-add-to-cart');
  const purchaseButton = surface?.querySelector('.product-details [ref="addToCartButton"]');
  if (!sticky || !purchaseButton) return () => {};
  const controller = new AbortController();
  const { signal } = controller;
  const mobile = window.matchMedia('(max-width: 749px)');
  let frame;
  const update = () => {
    const viewport = window.visualViewport;
    const suppressed = shouldSuppressStickyPurchase({
      hasPassed: purchaseButton.getBoundingClientRect().bottom <= 0,
      isMobile: mobile.matches,
      hasOverlay: Boolean(document.querySelector('dialog[open], #Details-menu-drawer-container[open], [role="dialog"][aria-modal="true"][aria-hidden="false"]')),
      hasFocusedField: Boolean(document.activeElement?.matches('input:not([type="hidden"]), textarea, select, [contenteditable="true"]')),
      keyboardVisible: Boolean(viewport && viewport.scale === 1 && window.innerHeight - viewport.height > 100),
    });
    sticky.toggleAttribute('data-precision-suppressed', suppressed);
  };
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(update);
  };
  const observer = new IntersectionObserver(schedule);
  observer.observe(purchaseButton);
  const dialogs = new MutationObserver(schedule);
  dialogs.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'aria-modal', 'aria-hidden', 'hidden'] });
  window.addEventListener('scroll', schedule, { passive: true, signal });
  window.addEventListener('resize', schedule, { passive: true, signal });
  document.addEventListener('focusin', schedule, { signal });
  document.addEventListener('focusout', schedule, { signal });
  mobile.addEventListener('change', schedule, { signal });
  window.visualViewport?.addEventListener('resize', schedule, { signal });
  update();
  return () => {
    controller.abort();
    observer.disconnect();
    dialogs.disconnect();
    cancelAnimationFrame(frame);
  };
}

/* Promote existing standalone Shopify section labels; never truncate product copy. */
class PrecisionProductDescription extends HTMLElement {
  connectedCallback() {
    this.cleanupSticky?.();
    this.cleanupSticky = guardStickyPurchase(this.closest('.precision-product-surface'));
    const content = this.querySelector('.rte');
    if (!content) return;
    let inQuestions = false;
    for (const paragraph of [...content.children]) {
      if (paragraph.tagName !== 'P' || paragraph.children.length !== 1) continue;
      const label = paragraph.firstElementChild;
      if (label.tagName !== 'STRONG' || label.textContent.trim() !== paragraph.textContent.trim()) continue;
      const text = label.textContent.trim();
      if (!text || text.length > 110) continue;
      if (/^Vanliga frågor$/i.test(text)) inQuestions = true;
      const heading = document.createElement(inQuestions && text.endsWith('?') ? 'h3' : 'h2');
      heading.append(...label.childNodes);
      paragraph.replaceWith(heading);
    }
  }

  disconnectedCallback() { this.cleanupSticky?.(); }
}
if (!customElements.get('precision-product-description')) customElements.define('precision-product-description', PrecisionProductDescription);
